import React, { useCallback, useState } from "react"
import locations from "./data"

import imgSeparador from "./../../../assets/images/packaging-delivery/separador.png"

import "./packaging-delivery-section-5.scss"

function PackagingDeliverySection5() {
  const [location, setLocation] = useState()

  const findLocation = useCallback(() => {
    let match = locations.find(element => {
      return element.label === location
    })
    return match ? match.items : locations[0].items
  }, [location])

  return (
    <div className="f-packaging-delivery-section-5">
      <div className="f-packaging-delivery-section-5__container">
        <p className="f-packaging-delivery-section-5__paragraph-1">
          Recuerda que todos los empaques Nosotras serán recibidos y pueden
          hacer parte de la economía circular, sin embargo, solo aquellos
          empaques de productos comprados (no muestras gratis o empaques
          individuales) te darán puntos.
        </p>
        <p className="f-packaging-delivery-section-5__paragraph-2">
          ¡Por cada sobre que envíes con 10 empaques Nosotras, ganarás 20 puntos
          y por cada empaque adicional te daremos 2 puntos más!* *Los puntos
          serán incluidos en tu banco de puntos una vez los empaques sean
          verificados, es decir, aproximadamente 20 días después de llevarlos a
          Servientrega.
        </p>
        <img
          src={imgSeparador}
          alt="Separador"
          className="f-packaging-delivery-section-5__img"
        />
        <div className="f-packaging-delivery-section-5__searcher" id="searcher">
          <h2 className="f-packaging-delivery-section-5__searcher__title">
            <b className="number-bold">¿</b>Ya tienes el sobre listo con los
            empaques de tus <span>Productos Nosotras?</span>
          </h2>
          <p className="f-packaging-delivery-section-5__searcher__paragraph-1">
            Encuentra el centro de Servientrega autorizado más cercano a tu
            casa: <br /> elige tu ciudad y conoce los centros autorizados de
            Servientrega en tu departamento.
          </p>
          <div className="f-packaging-delivery-section-5__searcher__find">
            <label
              className="f-packaging-delivery-section-5__searcher__find__label"
              htmlFor="state"
            >
              SELECCIONA TU CIUDAD:
            </label>
            <select
              name="state"
              id="state"
              className="f-packaging-delivery-section-5__searcher__find__select"
              onChange={e => {
                e.preventDefault()
                setLocation(e.target.value)
              }}
            >
              <option selected disabled>
                Ciudad
              </option>
              {locations.map(item => {
                return (
                  <option key={item.label} value={item.label}>
                    {item.label.toLowerCase()}
                  </option>
                )
              })}
            </select>
            <ul className="f-packaging-delivery-section-5__searcher__find__results">
              {findLocation().map(item => {
                return (
                  <li
                    className="f-packaging-delivery-section-5__searcher__find__results__item"
                    key={JSON.stringify(item.CODIGO)}
                  >
                    <span className="f-packaging-delivery-section-5__searcher__find__results__item__title">
                      {item.NOMBRE_PS.toLowerCase()}
                    </span>
                    <span className="f-packaging-delivery-section-5__searcher__find__results__item__subtitle">
                      {item.DIRECCION.toLowerCase()}
                    </span>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="f-packaging-delivery-section-5__searcher__info">
            <p className="f-packaging-delivery-section-5__searcher__info__p1">
              Participa llevando tus empaques a Servientrega, así ganamos todas.
            </p>
            <p className="f-packaging-delivery-section-5__searcher__info__p2">
              ¡PUNTOS PARA TI, LOVING PARA EL PLANETA!
            </p>
          </div>
        </div>
      </div>{" "}
    </div>
  )
}

export default PackagingDeliverySection5
